module.exports = __webpack_public_path__ + "img/Bild Abstand.2f459083.jpg";